import axios from 'axios';

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL ?? '';
const BASE_URL = `${BACKEND_URL}/api/skills`;

class SkillsService {
  async getSkills() {
    return axios.get(`${BASE_URL}/`);
  }

  async getCategories() {
    return axios.get(`${BASE_URL}/categories`);
  }
}

export default new SkillsService();